module.exports = __webpack_public_path__ + "img/account.14b521e6.svg";